import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ApiService } from './api.service';
import { AuthguardService } from "../guards/authguard.service";
import { RequestInterceptor } from '../interceptors/request.interceptor';
import {
    AuthService,
    AnalyticsService,
    CommonService,
    DashboardService,
    WidgetService,
    WidgethelperService,
    ReportService
}  from './';

import {
    CurrentinventoryService,
    InventoryaccuracyService,
    HospitalsummaryService,
    OrderstatusService,
    ProgresstrackingService,
    PulltimemonitorService,
    ReturnsavailabilityService,
    StorewaveprogressionService,
    TotalprogressionService,
    TotalactiveusersService,
    WaveprogressionService,
    WavepulltimemonitorService,
    WavestatusService,
    WavetrendService,
    WaveperformanceService,
    AgedtasksService,
    PackedunitsthroughputService,
    PickedunitsthroughputService,
    OpencctasksService,
    TotalcctasksService,
    AveragelocationccService,
    VarianceService,
    PutunitsthroughputService,
    WavesinqueueService,
    OpenpickstasksService,
    OpenreplenstasksService,
    AgedOrdersService,
    AgedordersputwallService,
    ParcelshipmentpctService,
    OntimeshipmentService,
    DefectivepartsService,
    OpenorderService,
    TransitionalInventoryService,
    CurrentStateService,
    PendingWaveTasksService,
    OpensorterordersService,
    MhemessagesService,
    TimeincubbyService,
    CancelorderService,
    ShortedordersService,
    UserperformanceService,
    OpenordersService,
    PutawaynotconsumedService,
    HospitalpackedService,
    OrderfillrateService,
    ZonebalancingService,
    OrdersummaryService,
    HourlyordersService,
    ForcePackwavesService,
    ToteRecirculatingService,
    MheNoReadDataService,
    BlindCountErrorService,
    LargewavetrendService,
    WavestatusdashboardService,
    PutwallstatusdashboardService,
    CubbystatusdashboardService,
    OrdersByStoreService,
    HospitalPackedOrdersService,
    MheMonitoringSummaryService
} from './widgets';

import { SignalRResolver } from '../resolvers/signalr.resolver';
import { ExcelGeneratorService } from './excel-generator.service';

@NgModule({
    providers: [
        AuthguardService,
        SignalRResolver,
        ApiService,
        AuthService,
        CommonService,
        ExcelGeneratorService,
        AnalyticsService,
        DashboardService,
        WidgetService,
        WidgethelperService,
        ReportService,
        AgedtasksService,
        CurrentinventoryService,
        InventoryaccuracyService,
        HospitalsummaryService,
        OrderstatusService,
        PackedunitsthroughputService,
        PickedunitsthroughputService,
        PutunitsthroughputService,
        ProgresstrackingService,
        PulltimemonitorService,
        ReturnsavailabilityService,
        StorewaveprogressionService,
        TotalprogressionService,
        TotalactiveusersService,
        WaveprogressionService,
        WavepulltimemonitorService,
        WavestatusService,
        WavetrendService,
        WaveperformanceService,
        OpencctasksService,
        TotalcctasksService,
        AveragelocationccService,
        VarianceService,
        WavesinqueueService,
        OpenpickstasksService,
        AgedOrdersService,
        AgedordersputwallService,
        ParcelshipmentpctService,
        OntimeshipmentService,
        DefectivepartsService,
        OpenorderService,
        TransitionalInventoryService,
        CurrentStateService,
        PendingWaveTasksService,
        OpensorterordersService,
        MhemessagesService,
        TimeincubbyService,
        CancelorderService,
        ShortedordersService,
        UserperformanceService,
        OpenreplenstasksService,
        HospitalpackedService,
        OpenordersService,
        OrderfillrateService,
        ZonebalancingService,
        OrdersummaryService,
        HourlyordersService,
        ForcePackwavesService,
        ToteRecirculatingService,
        MheNoReadDataService,
        BlindCountErrorService,
        PutawaynotconsumedService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        LargewavetrendService,
        WavestatusdashboardService,
        PutwallstatusdashboardService,
        CubbystatusdashboardService,
        OrdersByStoreService,
        HospitalPackedOrdersService,
        MheMonitoringSummaryService
    ]
})

export class ServiceModule { }



// WEBPACK FOOTER //
// ./src/app/services/service.module.ts